export class PseReturnTransaction {
    TRANSACTION_DATE: string = null;
    BANK: string = null;
    STATUS: string = null;
    TRAZABILITY_CODE: string = null;
    NIT: string = null;
    TICKET_ID: string = null;
}
